import styled from 'styled-components'

import { FreeGuideSignup } from './FreeGuideSignup'

const StyledBackground = styled.div`
  margin-bottom: 120px;
  background: #fbf8f3;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    margin-bottom: 32px;
  }
`

const StyledOverlay = styled.div`
  background-color: #ffd100;
  padding: 80px 0;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding: 64px 0 32px;
  }
`

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 100px auto;
  max-width: 800px;
  padding: 0;
  gap: 72px;

  img {
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
    max-height: 380px;
    border-radius: 8px;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 32px 24px;
    text-align: center;
    margin: 0;
    gap: 32px;
  }
`

const StyledContent = styled.div`
  color: ${(p) => p.theme.v2.onSurface.text};
  span {
    text-transform: uppercase;
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
  }
  h2 {
    font-size: ${(p) => p.theme.v2.typography.display.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    margin: 12px 0;
  }
  p {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
  }
`

export const FreeGuideLandingPageHeroSection = () => {
  return (
    <StyledBackground>
      <StyledOverlay>
        <StyledContainer>
          <img src="/assets/img/freeguide/freeguide.png" alt="Download free" width="270" height="380" />

          <StyledContent>
            <span>Free download</span>
            <h2>Live Healthier: Top 10 Tips From ZOE Science & Nutrition</h2>
            <p>
              After hundreds of hours of conversations with amazing scientists, we&apos;ve uncovered all sorts of
              insights to help you live better. Now, we&apos;ve created a free guide summarizing the top 10 discoveries
              from our podcast that you can apply to your life.
            </p>
          </StyledContent>
        </StyledContainer>
        <FreeGuideSignup />
      </StyledOverlay>
    </StyledBackground>
  )
}
